/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */
import { EColumnCell, EColumnFilter } from '../../../../../components/Table/types/columnTypes';
import { BillsField } from '../../../pageBillsTypes';

const cellConfig = {
    amount: 140,
    billDate: 140,
    billDebt: 140,
    billNumber: 140,
    billPaid: 140,
    billPeriod: 140,
    customer: 140,
    fucturies: 140,
    paidAmount: 140,
    paymentDate: 140,
    payStatus: 140,
    unpaidAmount: 140,
};
const getColumnFilterType = (name: string): string => {
    switch (name) {
        case BillsField.billNumber:
        case BillsField.customer:
        case BillsField.fucturies:
            return EColumnFilter.filterSearch;
        case BillsField.payStatus:
            return EColumnFilter.filterSelect;
        case BillsField.billDate:
        case BillsField.billPeriod:
        case BillsField.paymentDate:
            return EColumnFilter.filterDate;
        case BillsField.amount:
        case BillsField.billDebt:
        case BillsField.billPaid:
        case BillsField.paidAmount:
        case BillsField.unpaidAmount:
            return EColumnFilter.filterRange;
        default:
            return '';
    }
};
const getColumnCellType = (name: string): string => {
    switch (name) {
        case BillsField.customer:
            return EColumnCell.billsAccount;
        case BillsField.amount:
        case BillsField.billDebt:
        case BillsField.billPaid:
        case BillsField.paidAmount:
        case BillsField.unpaidAmount:
            return EColumnCell.amount;
        case BillsField.billDate:
        case BillsField.paymentDate:
            return EColumnCell.dateCell;
        case BillsField.billPeriod:
            return EColumnCell.billsPeriod;
        case BillsField.payStatus:
            return EColumnCell.billsPayStatus;
        case BillsField.billNumber:
        case BillsField.fucturies:
        default:
            return EColumnCell.text;
    }
};

const getColumnFixedType = (name: string): string | boolean => {
    switch (name) {
        case BillsField.billNumber:
            return 'left';
        default:
            return false;
    }
};

export {
    cellConfig,
    getColumnCellType,
    getColumnFilterType,
    getColumnFixedType,
};
